/**
 * Lista de Fundos
 * - Expand/collapse do painel de corretoras por item
 * - Mostra/oculta a lista inteira ao trocar o tipo de fundo no filtro
 *   (responde ao evento 'nossos-fundos-filter:change' com filter === 'tipo')
 */
export function initListaFundos() {
  const wrapper = document.querySelector('.lista-fundos:not(.lista-fundos--listados)');
  if (!wrapper) return;

  // ── Expand/collapse de corretoras ─────────────
  wrapper.querySelectorAll('.lista-fundos__item').forEach(item => {
    const toggleBtn  = item.querySelector('.lista-fundos__toggle');
    const linkVer    = item.querySelector('.lista-fundos__link-ver');
    const corretoras = item.querySelector('.lista-fundos__corretoras');

    if (!corretoras) return;

    function toggle() {
      const isOpen = item.classList.toggle('is-open');
      corretoras.hidden = !isOpen;
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', String(isOpen));
    }

    if (toggleBtn) toggleBtn.addEventListener('click', toggle);
    if (linkVer)   linkVer.addEventListener('click', toggle);
  });

  // Visibilidade controlada pelo global.js (coordena tipo + visualizacao)
}
